import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Modal from "react-modal";
// import { useNavigate } from 'react-router-dom';
import ModalHeadAndClose from "../common/ModalHeadAndClose";
import TabsCTO from "../payout-tabs/TabsCTO";
import ButtonDice from "../common/ButtonDice";
import CreateNewCTO from "../cto/CreateNewCTO";
import { fetchCTOData } from "../../../redux/reducers/apiSlice";
import { toast } from "react-toastify";
import { selectAuth } from "../../auth/auth.selector";

function LastMonthCTOdetails({ onClose, selectedGym }) {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const { ctoData, loading, error } = useSelector((state) => state.api);

  const [createCTOModal, setCreateCTOModal] = useState(false);
  const initialCTOTabsData = {
    allCTOData: [],
    wtfCTOData: [],
    gymCTOData: [],
  };
  const [allCTODataValues, setAllCTODataValues] = useState(initialCTOTabsData);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;

  const selectedGymQueryParam = selectedGym
    ? `&gym_id=${selectedGym?.value}`
    : "";
  const selectedYearQueryParam = currentYear ? `&year=${currentYear}` : "";
  const selectedMonthQueryParam = previousMonth
    ? `&month=${previousMonth}`
    : "";
  const queryParameters = `${selectedGymQueryParam}${selectedYearQueryParam}${selectedMonthQueryParam}`;

  const onClickCopyLastMonth = (e) => {
    e.preventDefault();
    if (selectedGym) {
      dispatch(fetchCTOData({ queryParameters, token: decryptedText?.token }));
    }
  };

  // useEffect(() => {
  //     if (selectedGym) {
  //         dispatch(fetchCTOData({ queryParameters, token: decryptedText?.token }));
  //     }
  // }, [selectedGym]);

  useEffect(() => {
    if (ctoData?.status && ctoData?.data?.length > 0) {
      const { data } = ctoData;

      const categorizedData = data.reduce(
        (acc, ctoItem) => {
          if (ctoItem.cto_type === "wtf") {
            acc.wtfCTOData.push(ctoItem);
          } else if (ctoItem.cto_type === "gym") {
            acc.gymCTOData.push(ctoItem);
          }
          return acc;
        },
        {
          wtfCTOData: [],
          gymCTOData: [],
        }
      );

      setAllCTODataValues({
        ...allCTODataValues,
        allCTOData: data,
        wtfCTOData: categorizedData.wtfCTOData,
        gymCTOData: categorizedData.gymCTOData,
      });
    } else {
      toast.error("NO CTO Found 😞");
    }
  }, [ctoData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <div className="outerContainer">
      <Modal
        isOpen={createCTOModal}
        onRequestClose={() => setCreateCTOModal(false)}
        contentLabel="Create New CTO Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title=""
            onClose={() => setCreateCTOModal(false)}
          />
          <CreateNewCTO
            queryParameters={queryParameters}
            onClose={() => setCreateCTOModal(false)}
          />
        </div>
      </Modal>

      <div className="addCtoHeadContainer settlementCtoModalContainer lastMonthCtoDetailsModalContainer">
        <ModalHeadAndClose title="" onClose={onClose} />

        <Row>
          <Col>
            <div className="noCTOfoundMessageContainer">
              <div className="innerNoCTOfoundMessageContainer">
                <h5 className="titleHead">No CTO Found !</h5>
                <span className="descDetails">
                  To continue, please either add the CTO or click the button
                  below to copy the CTO from the previous month
                </span>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <ButtonDice
              buttonText1="Copy Last Month"
              buttonText2="Create New"
              onClickButton1={onClickCopyLastMonth}
              onClickButton2={() => setCreateCTOModal(true)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <h3 className="titleHead">Last Month CTO</h3>
            <TabsCTO allCTODataValues={allCTODataValues} />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default LastMonthCTOdetails;
